import type { Environment } from './environment.model';



/** Default for `npm start` — local API + local uploads. */

export const environment: Environment = {

  name: 'local',

  // name: 'server',

  production: false,

 // baseUrl: 'http://localhost:3000',

 //uploadsBaseUrl: 'http://localhost:3000',

  // Remote API (only when backend is deployed there):

  // name: 'server',

  baseUrl: 'https://pptgen.ene-masterclass.com',

  uploadsBaseUrl: 'https://pptgen.ene-masterclass.com',

};


